import React, { useContext } from 'react'
import axios from 'axios'

import {
  CAvatar,
  CDropdown,
  CDropdownDivider,
  CDropdownItem,
  CDropdownMenu,
  CDropdownToggle,
} from '@coreui/react'
import { cilCreditCard } from '@coreui/icons'
import CIcon from '@coreui/icons-react'

import avatar8 from './../../assets/images/avatars/3.jpg'
import { Usercntxt } from './../../context/UserContext'
import { cacheClearForUser } from '../../services/cacheManager'
import { clearXeroContactsCache } from '../../services/xeroContactsCache'

const AppHeaderDropdown = () => {
  const user = useContext(Usercntxt)

  // Clear all IndexedDB databases on logout
  const clearAllIndexedDBCaches = async () => {
    try {
      // Clear Orders cache database
      const ordersDBReq = indexedDB.deleteDatabase('OrdersCacheDB')
      ordersDBReq.onsuccess = () => console.log('[Logout] Orders cache cleared')
      ordersDBReq.onerror = () => console.warn('[Logout] Failed to clear orders cache')

      // Clear Xero contacts cache database
      const xeroDBReq = indexedDB.deleteDatabase('XeroContactsCacheDB')
      xeroDBReq.onsuccess = () => console.log('[Logout] Xero contacts cache cleared')
      xeroDBReq.onerror = () => console.warn('[Logout] Failed to clear xero cache')
    } catch (error) {
      console.error('[Logout] Failed to clear IndexedDB caches:', error)
    }
  }

  const logoutSubmit = (e) => {
    e.preventDefault()

    const token = localStorage.getItem('auth_token')

    // Logout must not depend on the API responding before the client is signed out.
    axios
      .post('/api/logout', null, {
        timeout: 5000,
        headers: token ? { Authorization: `Bearer ${token}` } : {},
      })
      .catch((error) => console.warn('[Logout] Server logout failed:', error.message))

    cacheClearForUser()
    clearXeroContactsCache()
    clearAllIndexedDBCaches()
    user.setUser(null)

    localStorage.removeItem('auth_token')
    localStorage.removeItem('auth_name')
    localStorage.removeItem('auth_user_id')
    localStorage.setItem('user_logout_signal', JSON.stringify({ timestamp: Date.now() }))

    window.location.replace('/login')
  }

  return (
    <CDropdown variant="nav-item">
      <CDropdownToggle placement="bottom-end" className="py-0" caret={false}>
        <div className="me-2 d-inline">
          {user.userState?.name} ({user.userState?.role})
        </div>
        <CAvatar src={avatar8} size="md" />
      </CDropdownToggle>
      <CDropdownMenu className="pt-0" placement="bottom-end">
        <CDropdownItem href="/profile">
          <CIcon icon={cilCreditCard} className="me-2" />
          Profile
        </CDropdownItem>
        <CDropdownDivider />
        <CDropdownItem href="#" onClick={logoutSubmit}>
          Logout
        </CDropdownItem>
      </CDropdownMenu>
    </CDropdown>
  )
}

export default AppHeaderDropdown
